import { MainNavItem, PathNameMatchType } from './main-nav-item'
import styles from './main-nav.module.scss'
import { ProfileSettings } from './profile-settings/profile-settings'
import { useLocalPathName } from '../../hook/use-local-path-name'
import { GroupsNavSvgIcon, HamburgerSvgIcon, HomeNavSvgIcon, SeriesNavSvgIcon, WorkoutsNavSvgIcon } from '../util/images'
import { Logo } from '../util/logo'
import { isFeatureFlagged } from '../../util/feature-flags'
import { useExpandNavbarForAppTourWorkoutsStep } from '../../hook/use-expand-navbar-for-app-tour-workouts-step'
import React, { forwardRef, useState } from 'react'
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export const MainNav = forwardRef<HTMLElement>((props: unknown, ref): React.ReactElement => {
  const [pathName] = useLocalPathName()
  const [navExpanded, setNavExpanded] = useState(false)

  useExpandNavbarForAppTourWorkoutsStep(setNavExpanded)

  return (
    <>
      <Navbar
        expand="lg"
        className={`py-3 bg-black border-bottom border-tertiary-grey ${styles.halfSizeNavSM}`}
        sticky="top"
        onToggle={setNavExpanded}
        ref={ref}
        expanded={navExpanded}
      >
        <Container fluid>
          <Row className="flex-1">
            <Col>
              <Container>
                <Row className="flex-1 justify-between align-items-center">
                  <Navbar.Brand as={Link} to="/">
                    <Logo />
                  </Navbar.Brand>
                  <div className="d-flex align-items-center">
                    <div className="d-lg-none">
                      <ProfileSettings />
                    </div>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" className={styles.navbarToggleIcon}>
                      <HamburgerSvgIcon />
                    </Navbar.Toggle>
                  </div>
                  <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ml-auto">
                      <MainNavItem
                        currentPath={pathName}
                        title="Home"
                        path="/"
                        icon={<HomeNavSvgIcon />}
                        machType={PathNameMatchType.EXACT}
                        onClick={() => setNavExpanded(false)}
                      />
                      <div data-nextstep="nav-workouts">
                        <MainNavItem
                          currentPath={pathName}
                          title="Workouts"
                          path="/workouts"
                          icon={<WorkoutsNavSvgIcon />}
                          onClick={() => setNavExpanded(false)}
                        />
                      </div>
                      <MainNavItem
                        currentPath={pathName}
                        title="Series"
                        path="/programmes"
                        icon={<SeriesNavSvgIcon />}
                        onClick={() => setNavExpanded(false)}
                      />
                      {!isFeatureFlagged('GROUPS') && (
                        <MainNavItem
                          currentPath={pathName}
                          title="Groups"
                          path="/groups"
                          icon={<GroupsNavSvgIcon />}
                          onClick={() => setNavExpanded(false)}
                        />
                      )}
                    </Nav>
                    <Nav className="ml-auto">
                      {/* Development-only debug link */}
                      {process.env.NODE_ENV === 'development' && (
                        <Nav.Link as={Link} to="/debug" className="text-warning mr-2">
                          🐛 Debug
                        </Nav.Link>
                      )}
                      <div className="d-none d-lg-block">
                        <ProfileSettings />
                      </div>
                    </Nav>
                  </Navbar.Collapse>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </Navbar>
    </>
  )
})

MainNav.displayName = 'MainNav'
